import styled from 'styled-components';
import { Tab, Table } from 'semantic-ui-react';

export const StyledTableRow = styled(Table.Row)`
  @media (max-width: 1900px) {
    .buttons {
      display: inline-flex;
    }
  }
`;

export const StyledTab = styled(Tab)`
  overflow: auto;
  .secondary {
    width: max-content;
  }
`;

export const StyledCellValue = styled.p`
  margin: 0;
`;
